/********************************************* ASSETS *********************************************/
const s = require('../auth-panel-root.scss');
const mailSuccessImg = require('./envelope-success.svg');

/******************************************** IMPORTS *********************************************/
import React from 'react';
import DocumentTitle from 'react-document-title';
import cn from 'classnames';
import {FormSubmitHandler, Switch, Default, Case} from 'mad-utils/lib/react';

/**************************************** PROJECT MODULES *****************************************/
import {CloseWindowMessage} from '../auth-panel-input-utils';
import {translate, SubmitButton} from '@canimmunize/core-imports';

/**************************************** TYPE DEFINITIONS ****************************************/
interface EmailVerificationSuccessCardViewProps {
    navToLogin: FormSubmitHandler;
    platform: string | null;
}

/********************************************* STYLES *********************************************/
const topFlexContainer = cn(`flex col center ai-center`, `h-100p`, `p-50`);
const bottomFlexContainer = cn(`flex col center ai-center`, `h-125`, `mb-10`);

/********************************************* EXPORT *********************************************/
/**
 * View for page showing email verification succeeded
 * If [navToLogin] is true, show link to return to login page
 * Determine close window message based on [navToLogin] value
 */
export const EmailVerificationSuccessCardView = (props?: EmailVerificationSuccessCardViewProps) => {
    const pageTitle = `${translate('title_email_verification_success')} - CANImmunize`;

    return (
        <DocumentTitle title={pageTitle}>
            <div className={cn(`h-100p`, s[`input-card`])}>
                <div className={cn(`flex column`, `h-100p`)}>
                    <div className={cn(topFlexContainer)}>
                        <div>
                            <img src={mailSuccessImg} className={cn(`h-85`, `mb-10`)} />
                        </div>
                        <h1 className={cn(s[`input-card-text`])}>
                            {translate(`success_verification`)}
                        </h1>
                        <h2 className={cn(s[`input-card-text`])}>
                            {translate(`you_may_now_log_in_to_the_app`)}
                        </h2>
                    </div>
                    <div className={cn(bottomFlexContainer)}>
                        <Switch test={props.platform && props.platform !== `web`}>
                            <Case val={true}>
                                <CloseWindowMessage />
                            </Case>
                            <Default>
                                <SubmitButton onClick={props.navToLogin} mergeClasses={cn(`mb-20`)}>
                                    {translate(`get_started`).toUpperCase()}
                                </SubmitButton>
                            </Default>
                        </Switch>
                    </div>
                </div>
            </div>
        </DocumentTitle>
    );
};

EmailVerificationSuccessCardView.displayName = `EmailVerificationSuccessCardView`;
